import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import ForgotPassword from './containers/forgotPassword';
import ResetPassword from './containers/resetPassword';
import Login from './containers/login';
import UserRegistration from './containers/userRegistration';
import UserManagement from './pages/UserManagement';
import TestingIntegration from './pages/TestingIntegration';
// import RegisterCustomer from './pages/RegisterCustomer';
import MemberManagement from './pages/MemberManagement';
import './App.css';
// import Carousel from './pages/CreateCarouselTemplate';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SendMessage from './pages/SendMessage';
import TemplateRegister from './pages/TemplateRegister';
import BulkMarketing from './pages/BulkMarketing';

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [sidebarCollapsed] = useState(false);

  useEffect(() => {
    const storedLoginStatus = localStorage.getItem('isLoggedIn');
    if (storedLoginStatus === 'true') {
      setIsLoggedIn(true);
    }
  }, []);

  const handleLogin = () => {
    setIsLoggedIn(true);
    localStorage.setItem('isLoggedIn', 'true');
  };

  return (
    <Router>
      {isLoggedIn ? (
        <div className={`app-container ${sidebarCollapsed ? 'collapsed' : ''}`}>
          <div className="main-content">
            <Routes>
              <Route path="/usermanagement" element={<UserManagement />} />
              <Route path="/testingIntegration" element={<TestingIntegration />} />
              <Route path="/message" element={<SendMessage />} />
              <Route path="/template" element={<TemplateRegister />} />
              {/* <Route path="/RegisterCustomer" element={<RegisterCustomer />} />*/}
              <Route path="/memberManagement" element={<MemberManagement />} /> 
              <Route path="/reset-password" element={<ResetPassword />} />
              {/* <Route path="/carousel" element={<Carousel />} /> */}
              <Route path="/marketing" element={<BulkMarketing />} />
              <Route path="*" element={<Navigate to={localStorage.getItem('lastPath') || "/usermanagement"} />} />
            </Routes>
          </div>
        </div>
      ) : (
        <Routes>
          <Route path="/" element={<Login onLogin={handleLogin} />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/login" element={<Login onLogin={handleLogin} />} />
          <Route path="/signUp" element={<UserRegistration />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      )}
      <ToastContainer />
    </Router>
  );
};

export default App;
